import { useCallback } from 'react';

import { trackEvent } from '@zep/logger/tracking';

import { useAiBuilderChatActions } from '../store';
import { type OpenAiBuilderChatParams } from '../store/types';

import { useAiBuilderChatAvailability } from './useAiBuilderChatAvailability';

export const useOpenAiBuilderChat = () => {
  const { openFromEntry } = useAiBuilderChatActions();
  const { canUseAiBuilderChat } = useAiBuilderChatAvailability();

  return useCallback(
    (params: OpenAiBuilderChatParams) => {
      if (!canUseAiBuilderChat) {
        return;
      }

      openFromEntry(params);
      trackEvent('quiz_ai_builder_chat_open', {
        entry: params.entry,
        source: params.source,
      });
    },
    [canUseAiBuilderChat, openFromEntry],
  );
};
